import { render } from "./PanelGroup.vue?vue&type=template&id=0ef8a5e9&scoped=true&ts=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"

import "./PanelGroup.vue?vue&type=style&index=0&id=0ef8a5e9&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef8a5e9"]])

export default __exports__